

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls,apiHostUrl,unauth } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const confirmationApi = createApi({
    reducerPath: 'confirmation',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers, unauth);
        }
        
    }),
    endpoints: (builder) => ({
        getConfirmationByName: builder.query({
            query: (payload) => ({
                url: unauth ? apiUrls?.itpNsaPlanSummaryUrl_ua : apiUrls?.itpNsaConfirmPlanUrl,
                method: 'POST',
                body: payload
            })
        }),
        getSendEmailByName:builder.query({
            query: (payload) => ({
                url: apiUrls?.itpNsaSendEmailUrl,
                method: 'POST',
                body: payload
            })
        }),
    }),
})

export const { useGetConfirmationByNameQuery,useLazyGetSendEmailByNameQuery} = confirmationApi;
